<div class="conta-barra-container" *ngIf="deveExibirBarraConta()"
     [class.powered-by]="empresa?.exibirPoweredBy">
  <div class="conta-barra">
    <button class="conta-barra-resumo" type="button" (click)="abraConta()"
            aria-haspopup="dialog" aria-label="Ver detalhes da conta da comanda">
      <span class="conta-barra-titulo" *ngIf="!erroConta">Sua comanda · {{quantidadeItensConta()}} {{quantidadeItensConta() === 1 ? 'item' : 'itens'}}</span>
      <span class="conta-barra-titulo" *ngIf="erroConta">Sua comanda</span>
      <span class="conta-barra-subtitulo" *ngIf="podePagarPixConta()">Ver conta <i class="fas fa-chevron-up" aria-hidden="true"></i></span>
    </button>
    <button class="conta-barra-pix" type="button" *ngIf="podePagarPixConta()" (click)="pagueComPix()">
      <app-icone-pix [tamanho]="17"></app-icone-pix>
      <span>Pagar com Pix</span>
    </button>
    <button class="conta-barra-ver" type="button" *ngIf="!podePagarPixConta()" (click)="abraConta()"
            aria-haspopup="dialog">
      Ver Conta
      <i class="fas fa-chevron-up" aria-hidden="true"></i>
    </button>
  </div>
</div>

<div class="conta-sheet-fundo" *ngIf="folhaContaAberta" (click)="fecheConta()" aria-hidden="true"></div>
<section class="conta-sheet" *ngIf="folhaContaAberta" role="dialog" aria-modal="true"
         aria-labelledby="titulo-conta-sheet">
  <div class="conta-sheet-puxador" aria-hidden="true"></div>
  <header class="conta-sheet-cabecalho">
    <div>
      <h2 id="titulo-conta-sheet">Conta da {{comandaResumo?.empresa?.identificadorMesa || 'Mesa'}} {{comandaResumo?.mesa?.nome || pedido?.mesa?.nome}}</h2>
      <p>Comanda {{comandaResumo?.codigoCartaoCliente || comandaResumo?.codigo || pedido?.comandaValidada?.codigoCartaoCliente}}</p>
    </div>
    <button type="button" class="conta-sheet-fechar" (click)="fecheConta()" aria-label="Fechar conta">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </header>

  <div class="conta-sheet-carregando" *ngIf="carregandoConta" aria-live="polite">
    <span class="conta-sheet-spinner" aria-hidden="true"></span>
    Atualizando sua conta…
  </div>

  <div class="conta-sheet-erro" *ngIf="!carregandoConta && erroConta" role="alert">
    <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
    <span>{{erroConta}}</span>
    <button type="button" (click)="carregueResumoConta()">Tentar novamente</button>
  </div>

  <ng-container *ngIf="!carregandoConta && !erroConta && comandaResumo">
    <div class="conta-sheet-saldo">
      <span>Saldo a pagar</span>
      <strong>{{comandaResumo.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
    </div>

    <button class="conta-sheet-pagar" type="button" (click)="pagueComPix()" *ngIf="podePagarPixConta()">
      <app-icone-pix [tamanho]="20"></app-icone-pix>
      <span>Pagar com Pix</span>
      <strong>{{comandaResumo.saldoPagar | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
    </button>
    <small class="conta-sheet-nota" *ngIf="podePagarPixConta()">
      Aprovação na hora — a comanda fecha sozinha depois do Pix.
    </small>

    <button class="conta-sheet-itens-toggle" type="button" (click)="alterneItensConta()"
            [attr.aria-expanded]="itensContaExpandidos">
      <span>{{itensContaExpandidos ? 'Ocultar itens' : (quantidadeItensConta() === 1 ? 'Ver o item da conta' : 'Ver os ' + quantidadeItensConta() + ' itens da conta')}}</span>
      <i class="fas" [class.fa-chevron-down]="!itensContaExpandidos" [class.fa-chevron-up]="itensContaExpandidos"
         aria-hidden="true"></i>
    </button>

    <div class="conta-sheet-detalhes" *ngIf="itensContaExpandidos">
      <div class="conta-sheet-pedidos">
        <ng-container *ngFor="let pedidoConta of pedidosValidosConta()">
          <div class="conta-sheet-item" *ngFor="let item of pedidoConta.itens">
            <span class="conta-sheet-quantidade">{{item.qtde}}×</span>
            <span class="conta-sheet-descricao">{{item.descricao}}</span>
            <strong>{{item.total | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</strong>
          </div>
        </ng-container>
      </div>

      <div class="conta-sheet-resumo">
        <div>
          <span>Subtotal</span>
          <span>{{(comandaResumo.valor + comandaResumo.desconto) | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div class="conta-sheet-desconto" *ngIf="comandaResumo.desconto > 0">
          <span>Desconto</span>
          <span>− {{comandaResumo.desconto | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div *ngIf="comandaResumo.taxaServico > 0">
          <span>Taxa de serviço</span>
          <span>{{comandaResumo.taxaServico | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
        <div class="conta-sheet-desconto" *ngFor="let pagamento of pagamentosConfirmadosConta()">
          <span>{{pagamento.descricao || 'Pagamento anterior'}}</span>
          <span>− {{pagamento.valor | currency:'BRL':'symbol':'1.2-2':'pt-BR'}}</span>
        </div>
      </div>
    </div>

    <div class="conta-sheet-feedback" *ngIf="avisoConta" role="status" aria-live="polite">{{avisoConta}}</div>

    <footer class="conta-sheet-acoes">
      <ng-container *ngIf="podePagarPixConta(); else acoesSemPix">
        <button class="conta-sheet-continuar" type="button" (click)="fecheConta()">
          <i class="fas fa-utensils" aria-hidden="true"></i>
          Continuar pedindo
        </button>
        <button class="conta-sheet-garcom" type="button" (click)="soliciteGarcomConta()" [disabled]="solicitandoGarcomConta">
          <i class="far fa-bell" aria-hidden="true"></i>
          {{solicitandoGarcomConta ? 'Chamando garçom…' : 'Prefiro pedir a conta ao garçom'}}
        </button>
      </ng-container>
      <ng-template #acoesSemPix>
        <button class="conta-sheet-garcom conta-sheet-garcom-destaque" type="button" (click)="soliciteGarcomConta()"
                [disabled]="solicitandoGarcomConta">
          <i class="far fa-bell" aria-hidden="true"></i>
          {{solicitandoGarcomConta ? 'Chamando garçom…' : 'Pedir a conta ao garçom'}}
        </button>
        <button class="conta-sheet-continuar" type="button" (click)="fecheConta()">
          <i class="fas fa-utensils" aria-hidden="true"></i>
          Continuar pedindo
        </button>
        <small>A equipe leva a conta até você — pague como preferir na mesa.</small>
      </ng-template>
    </footer>
  </ng-container>
</section>

<div class="tab-bar" [hidden]="!exibirMenu" [ngClass]="{'powered-by': empresa?.exibirPoweredBy}">

    <a class="tab-item" (click)="clicouExibirMenuCategorias()" [ngClass]="{'ativo': estaNaBuscaPorCategoria}" [hidden]="!exibirMenuCategorias">
      <div class="tab-icon">   <i class="fe-filter"></i>    </div>
      <div class="tab-title">      Categorias  </div>
    </a>

    <a class="tab-item" (click)="navegueParaHome()"
       [ngClass]="{'ativo': estaNoHome}" >
      <div class="tab-icon">  <i class="fe-home"></i></div>
      <div class="tab-title"> Home</div>
    </a>

    <a class="tab-item" [hidden]="empresa?.exibirBrindes" (click)="busqueProdutos()" [ngClass]="{'ativo': url.startsWith('busca')}">
      <div class="tab-icon">      <i class="fe-search"></i>     </div>
      <div class="tab-title">    Busca </div>
    </a>

    <a class="tab-item" [hidden]="!empresa?.exibirBrindes" (click)="exibirTelaBrindes()" [ngClass]="{'ativo': url.startsWith('brindes')}">
      <div class="tab-icon">  <i class="fe-award"></i>     </div>
      <div class="tab-title">    Brindes </div>
    </a>


    <a class="tab-item" (click)="naveguePara('meusPedidos')"   [ngClass]="{'ativo': url==='meusPedidos'}">
      <div class="tab-icon">
        <i class="fe-shopping-bag"></i>
      </div>
      <div class="tab-title">
        Pedidos
      </div>
    </a>

    <a class="tab-item " (click)="naveguePara('perfil')"
       [ngClass]="{'ativo': url==='perfil' || url.indexOf('cadastro') >=0 || url==='login'}" *ngIf="empresa && empresa.tema !== 'quiosque'">
      <div class="tab-icon">
        <i class="fe-user"></i>
      </div>
      <div class="tab-title" *ngIf="usuario?.telefone">
        Perfil
      </div>
      <div class="tab-title" *ngIf="!usuario || !usuario.telefone">
        Entrar
      </div>
    </a>
  <app-powered-by></app-powered-by>
</div>
